import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.746 10c0-.795.148-1.556.419-2.255A1 1 0 0 0 4.7 7.9h.922a4.854 4.854 0 0 0 6.478 6.478v.922c0 .197.057.38.155.535A6.254 6.254 0 0 1 3.745 10m12.09 2.255a6.254 6.254 0 0 0-8.09-8.09 1 1 0 0 1 .154.535v.922a4.854 4.854 0 0 1 6.478 6.478h.922c.197 0 .38.057.535.155",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 3.7a.7.7 0 0 1 .7-.7h4.2a.7.7 0 0 1 .7.7v4.2a.7.7 0 0 1-.7.7H3.7a.7.7 0 0 1-.7-.7zm1.4.7v2.8h2.8V4.4zm7 7.7a.7.7 0 0 1 .7-.7h4.2a.7.7 0 0 1 .7.7v4.2a.7.7 0 0 1-.7.7h-4.2a.7.7 0 0 1-.7-.7zm1.4.7v2.8h2.8v-2.8z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=ProofCircleSolidIcon20.js.map